import groq from 'groq';

import { BACKGROUND, OVERLINE, SCROLL_VIDEO } from '../common';

export const BANNER_MEDIA = groq`
  _type,
  _type == "background" => {
    ${BACKGROUND}
  },
  _type == "scrollVideo" => {
    video {
      ${SCROLL_VIDEO}
    },
    overlayColor {
      hex
    }
  }
`;

export const BANNER = groq`
  ${OVERLINE},
  title,
  subtitle,
  link {
    href,
    title,
  },
  "layout": coalesce(layout, "standard"),
  media[0] {
    ${BANNER_MEDIA}
  },
  "isForceWhiteText": coalesce(isForceWhiteText, false),
  disclaimer
`;

export const BANNER_BLOCK = groq`
  _type == 'timeline_banner' => {
    ${BANNER}
  }
`;
